import { Empty } from 'antd';

const EmptyScreen = () => <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;

export default EmptyScreen;
